export function getInvertedX(x: number | string) {
  return typeof x === 'string' ? `-${x}` : x * -1;
}
